module.exports = __webpack_public_path__ + "img/29_66.55b07395.png";